import { useEffect, useRef } from 'react';
import { trackPageView, TrackPageViewDataType } from 'utils/analytics';

export const useAnalytics = () => {
  const usePageViewTracking = (data: TrackPageViewDataType, dependencies: any[] = []) => {
    const isMountedRef = useRef(false);
    // Track Page View in Google Analytics taking in custom data
    useEffect(() => {
      if (!isMountedRef.current) {
        trackPageView(data);
      }
    }, dependencies);
  };

  return {
    usePageViewTracking,
  };
};
